import { ReactElement, useMemo } from 'react'
import {
  ADD_PROMPT,
  AddToListStage,
  useAddToListStore,
} from 'src/store/lists/AddToListStore'
import styled from 'styled-components'
import Stage from './Stage'
import { Status } from './interfaces'
import { observer } from 'mobx-react-lite'

const BaseStage = {
  1: 'chooseMethod',
  2: 'addPrompt',
  3: 'validate',
  4: 'review',
}

const ImportStages = {
  ...BaseStage,
  2: 'chooseFile',
}

const ManualStages = {
  ...BaseStage,
  2: 'enterItems',
}

interface Stage {
  step: number
  label: string
  active: boolean
}

const Stages = observer((): ReactElement => {
  const addToListStore = useAddToListStore()
  const method = addToListStore.getSelectedPrompt()
  const currentStage = addToListStore.getStage()

  const stages = useMemo(
    () => (method == ADD_PROMPT.MANUAL ? ManualStages : ImportStages),
    [method]
  )

  const steps = useMemo(
    () =>
      Object.keys(AddToListStage)
        .filter((v) => isNaN(Number(v)))
        .map((s) => AddToListStage[s]),
    []
  )

  const getStatus = (step, currentStage) => {
    if (step < currentStage) return Status.COMPLETED
    if (step == currentStage) return Status.ACTIVE
    return Status.PENDING
  }

  return (
    <Wrapper>
      {steps.map((step, index) => (
        <Flex key={`stage_${stages[step]}_${index}`}>
          <Stage
            number={step}
            name={stages[step]}
            status={getStatus(step, currentStage)}
          />
          {index < steps.length - 1 && <Separator />}
        </Flex>
      ))}
    </Wrapper>
  )
})

const Wrapper = styled.div`
  display: flex;
  margin: 0.2rem 0rem 0.2rem 0rem;
`

const Separator = styled.hr`
  width: 24px;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`

const Flex = styled.div`
  display: flex;
`

export default Stages
